import type { ElementType, HTMLAttributes } from "react";
import type { SpaceScale } from "./Stack";
import "./layout.css";

export interface ClusterProps extends HTMLAttributes<HTMLDivElement> {
  /** Gap between children, from the --space-* scale. Default 4 (var(--space-4)). */
  gap?: SpaceScale;
  /** cross-axis alignment (align-items). */
  align?: "start" | "center" | "end" | "stretch";
  /** main-axis alignment (justify-content). */
  justify?: "start" | "center" | "end" | "between" | "space-between" | "around";
  as?: ElementType;
}

const JUSTIFY: Record<NonNullable<ClusterProps["justify"]>, string> = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  between: "space-between",
  "space-between": "space-between",
  around: "space-around",
};

/** Horizontal, wrapping flex layout. Use instead of inline style={{ display: "flex", flexWrap: "wrap", gap }}. */
export function Cluster({ gap = 4, align, justify, as: Component = "div", className, ...rest }: ClusterProps) {
  const classes = ["ui-cluster", `ui-gap-${gap}`, className].filter(Boolean).join(" ");
  const style =
    align || justify
      ? { alignItems: align, justifyContent: justify ? JUSTIFY[justify] : undefined }
      : undefined;
  return <Component className={classes} style={style} {...rest} />;
}
